import React from 'react';
import './SocialLink.css';

const SocialLink = ({ link, index }) => {
    const handleClick = () => {
        console.log(`Clic sur: ${link.title}`);
    };

    return (
        <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="link-item"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={handleClick}
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
        >
            <div className={`link-icon ${link.color}`}>
                {link.logo ? (
                    <img src={link.logo} alt={link.title} className="link-logo-img" draggable={false} onDragStart={(e) => e.preventDefault()} />
                ) : (
                    <i className={link.icon}></i>
                )}
            </div>
            <div className="link-content">
                <div className="link-title">{link.title}</div>
                <div className="link-description">{link.description}</div>
            </div>
            <div className="link-arrow">
                <i className="fas fa-arrow-right"></i>
            </div>
        </a>
    );
};

export default SocialLink;